// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"014ad0d1","168":"b1cc563b","512":"0cb3effa","988":"35a2aa58"}[chunkId] + ".chunk.js";
};